<ion-card class="program-card">
    <!-- Desktop images -->
    <div class="program-image-thumbnail">
        <img
            class="program-image"
            [src]="program?.image | img: program?.state:'md'"
        />
        <ion-card-title class="program-title">{{
            program?.name | truncate: [65, '...']
        }}</ion-card-title>
    </div>
    <div>
        <ion-item lines="none" class="mobile-search-card">
            <!-- thumbnail for mobile images -->
            <ion-thumbnail class="mobile-image-thumbnail">
                <img [src]="program?.image | img: program?.state:'sm'" />
                <!-- <p class="mobile-program-price"  *ngIf="!(hidePrices$ | async)">${{ program?.price }} USD</p> -->
            </ion-thumbnail>
            <ion-label class="ion-text-wrap">
                <div class="program-text-container">
                    <div class="program-content">
                        <p class="mobile-program-name">
                            {{ program?.name | truncate: [65, '...'] }}
                        </p>
                        <!-- <p class="program-text text-price bold-text">${{ program?.price }} USD</p> -->
                        <p
                            class="program-text text-price bold-text"
                            [innerHTML]="program | splitPrice"
                            *ngIf="!(hidePrices$ | async)"
                        ></p>
                        <p class="program-text">
                            <fa-icon
                                [icon]="icons.pin"
                                class="location-pin"
                            ></fa-icon>
                            {{ program?.city }}, {{ program?.state }}
                        </p>
                        <ion-chip *ngFor="let type of types">
                            <p class="program-type-text">{{ type }}</p>
                        </ion-chip>
                        <div
                            class="priceContainer"
                            *ngIf="!(hidePrices$ | async)"
                        >
                            <p
                                class="mobile-program-price"
                                *ngIf="!program?.priceDropPrice"
                            >
                                ${{ program?.price }} USD
                            </p>
                            <p
                                class="mobile-program-price-line-through"
                                *ngIf="program?.priceDropPrice"
                            >
                                ${{ program?.price }} USD
                            </p>
                            <p
                                *ngIf="program?.priceDropPrice"
                                class="mobile-program-price-drop"
                            >
                                ${{ program?.priceDropPrice }} USD$$
                            </p>
                        </div>
                    </div>
                    <div class="seats-container" slot="end">
                        <div>
                            <div class="seat-number">
                                {{ program?.offered }}
                            </div>
                            <p class="seat-text" *ngIf="program?.offered === 1">
                                seat<br />offered
                            </p>
                            <p class="seat-text" *ngIf="program?.offered > 1">
                                seats<br />offered
                            </p>
                        </div>
                    </div>
                </div>
            </ion-label>
            <fa-icon [icon]="icons.arrow" class="details-arrow"></fa-icon>
        </ion-item>
    </div>
</ion-card>
